import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentContainer } from '../../../../core/content-container/content-container';

const COMMUNITY_WHATSAPP_URL =
  'https://chat.whatsapp.com/IC1xQUy6xQm1WbUSLInjwQ';

@Component({
  selector: 'app-mentorship-community',
  imports: [ContentContainer],
  templateUrl: './mentorship-community.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MentorshipCommunity {
  protected readonly communityWhatsappUrl = COMMUNITY_WHATSAPP_URL;
}
